import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IFormSearchBody, IFormSearchResult, IFormSearchResultRecord } from '@assess/shared/data-mart-search';

import { SearchService } from './search.service';

@Injectable({ providedIn: 'root' })
export class FormSearchService {
  private readonly resourceType = 'form';

  constructor(private readonly searchService: SearchService) {}

  search(body: Partial<IFormSearchBody>): Observable<IFormSearchResult> {
    return this.searchService.search<IFormSearchResultRecord>(this.resourceType, body);
  }
}
